Vue.component('specialCards', {
  template: templates.specialCards,
  data() {
    return {
      model: {
        edit: false,
        card: {
          name: null,
          xpMultiplier: 0,
          userLimit: 0,
          active: false,
        },
        cards: {},
        spinning: false
      },
    };
  },
  mounted() {
    const c = this;
    c.get();
  },
  methods: {
    get() {
      const c = this;
      let data = {};
      specialCardService
        .get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.cards = data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    edit(id) {
      const c = this;
      let data = c.model.cards[`${id}`];
      if (id == c.model.card.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }
      c.model.card = {
        id: id,
        name: data.name,
        xpMultiplier: data.xpMultiplier,
        userLimit: data.userLimit,
        active: data.active,
      };
    },
    add() {
      const c = this;
      c.model.edit = true;
    },
    save() {
      const c = this;
      const data = c.model.card;
      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      }
      if (data.active && (data.xpMultiplier == 0 || data.userLimit == 0)) {
        utils.alert.error(
          'XP Multiplier and Limit are required to activate a card.'
        );
        return;
      }
      specialCardService
        .save(data)
        .then(function (response) {
          if (data.id) {
            c.model.cards[`${data.id}`] = data;
          } else {
            data.id = response.data.id;
            c.model.cards[`${data.id}`] = data;
          }
          c.reset();
          utils.alert.success('Saved!');
        })
        .catch(function (error) {
          utils.alert.error('Failed to save.');
        });
    },
    reset() {
      const c = this;
      c.model.edit = false;
      c.model.card = {
        name: null,
        xpMultiplier: 0,
        userLimit: 0,
        active: false,
      };
    },
  },
});
